import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGetStarted = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 70 70"
    {...props}
  >
    <path
      stroke="#4B7EFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M23.215 23.215 11.43 11.43m0 47.14 11.785-11.785m23.57 0L58.57 58.57m0-47.14L46.785 23.215M68.333 35c0 18.41-14.923 33.333-33.333 33.333S1.667 53.41 1.667 35 16.59 1.667 35 1.667C53.41 1.667 68.333 16.59 68.333 35m-16.666 0c0 9.205-7.462 16.667-16.667 16.667S18.333 44.205 18.333 35 25.795 18.333 35 18.333 51.667 25.795 51.667 35"
    />
  </svg>
);
export default SvgGetStarted;
